<template>
  <div class="modal fade" ref="modalElement" tabindex="-1" aria-labelledby="stemErrorLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">    
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title" id="stemErrorLabel">{{ title }}</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'stemError',
  data() {
    return {
      title: '',
      message: ''
    }
  },
  methods: {
    show(title, message) {
      this.title = title;
      this.message = message;
      
      const modal = new Modal(this.$refs.modalElement);
      modal.show();
    }
  }
};
</script>